export interface NewsArticle {
  id: number;
  title: string;
  date: string;
  summary: string;
  cover: string;
  content: string[];
}

export const newsList: NewsArticle[] = [
  {
    id: 1,
    title: "《星际远征》上映首周票房破十亿，口碑持续走高",
    date: "2025-10-02",
    summary: "这部备受期待的科幻巨制凭借震撼的视觉效果与深刻的情感内核，成为今年秋季档最大黑马，观众评分稳居同档期第一。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20news%20banner%2C%20astronauts%20walking%20across%20a%20glowing%20alien%20planet%20surface%2C%20deep%20blue%20and%20orange%20tones%2C%20epic%20sci-fi%20atmosphere%2C%20dramatic%20lighting%2C%20high%20detail%20editorial%20photography&width=1200&height=700&seq=news-cover-01&orientation=landscape",
    content: [
      "由国际知名团队打造的科幻巨制《星际远征》自上映以来持续引发观影热潮。影片上映首周票房正式突破十亿元大关，成为今年秋季档表现最亮眼的作品。",
      "影片讲述了人类远征舰队穿越虫洞寻找新家园的故事，既有宏大的宇宙奇观，也有细腻动人的情感刻画。不少观众表示，影片中关于时间与牺牲的探讨令人久久难以平静。",
      "业内人士分析，《星际远征》的成功不仅在于其顶级的视觉特效，更在于它用一个科幻外壳包裹了一个关于希望与选择的故事，这正是它能打动各年龄层观众的关键。",
      "随着口碑持续发酵，多家影院已宣布延长《星际远征》的放映周期，并增加了 IMAX 场次，以满足观众的观影需求。",
    ],
  },
  {
    id: 2,
    title: "秋季档片单出炉：多部高口碑影片定档十月",
    date: "2025-09-28",
    summary: "从科幻大片到温情文艺片，十月影院将迎来一波密集上映潮，类型丰富程度创下近年新高。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20autumn%20movie%20season%20banner%2C%20empty%20red%20cinema%20seats%20with%20warm%20projector%20light%20beam%2C%20deep%20amber%20and%20dark%20tones%2C%20cozy%20atmospheric%20mood%2C%20high%20detail%20editorial%20photography&width=1200&height=700&seq=news-cover-02&orientation=landscape",
    content: [
      "随着暑期档收官，影市即将迎来内容同样丰富的秋季档。据最新公布的上映计划，十月将有超过二十部新片陆续与观众见面。",
      "其中既有备受期待的科幻大片，也有口碑文艺片与合家欢动画。业内人士认为，多元化的片单有助于吸引不同偏好的观众走进影院。",
      "从目前点映反馈来看，几部文艺向作品的口碑表现尤为突出，有望成为秋季档的惊喜之作。",
    ],
  },
  {
    id: 3,
    title: "《暗夜追凶》预告片发布，悬疑氛围拉满",
    date: "2025-09-20",
    summary: "短短两分钟的预告片信息量巨大，雨夜追凶的画面质感和配乐设计让观众直呼过瘾。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20banner%2C%20rain%20soaked%20neon%20city%20street%20at%20night%20with%20empty%20police%20car%20lights%2C%20deep%20blue%20and%20amber%20tones%2C%20tense%20mysterious%20mood%2C%20high%20detail%20editorial%20photography&width=1200&height=700&seq=news-cover-03&orientation=landscape",
    content: [
      "备受关注的犯罪悬疑片《暗夜追凶》近日发布了首支正式预告片，迅速登上多个平台的热搜榜单。",
      "预告片中，雨夜、霓虹、长镜头交错呈现，营造出扑面而来的压迫感。短短两分钟里，导演巧妙地埋下了大量线索，让热衷于推理的观众们纷纷展开解读。",
      "片方透露，影片在剧本阶段历经多次打磨，力求呈现一个逻辑严密又充满反转的故事。",
    ],
  },
  {
    id: 4,
    title: "电影资料馆推出经典修复专题展映",
    date: "2025-09-12",
    summary: "十余部影史经典经过 4K 修复后重登大银幕，为影迷带来一次穿越时光的观影体验。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20classic%20film%20restoration%20banner%2C%20vintage%20film%20reels%20and%20projector%20casting%20warm%20light%20in%20a%20dark%20archive%20room%2C%20deep%20amber%20and%20sepia%20tones%2C%20nostalgic%20mood%2C%20high%20detail%20editorial%20photography&width=1200&height=700&seq=news-cover-04&orientation=landscape",
    content: [
      "为了向影史经典致敬，电影资料馆特别策划了经典修复专题展映活动，多部曾影响一代人的作品将以全新面貌回归。",
      "本次展映的所有影片均完成了 4K 级别的画质修复，并在音效上进行了重新混录，观众将有机会在大银幕上重温那些熟悉的经典瞬间。",
      "活动负责人表示，希望借由这次展映，让更多年轻观众了解电影艺术的发展脉络，感受经典作品的持久魅力。",
    ],
  },
  {
    id: 5,
    title: "年度动画黑马诞生：《小怪物大冒险》逆袭登顶",
    date: "2025-09-05",
    summary: "上映前并不被看好的原创动画，凭借扎实的剧本与治愈的故事，一路逆袭成为年度现象级作品。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20animated%20film%20news%20banner%2C%20colorful%20whimsical%20forest%20scene%20with%20glowing%20lanterns%20and%20tiny%20cute%20creatures%2C%20vibrant%20teal%20and%20orange%20palette%2C%20joyful%20magical%20mood%2C%20high%20detail%20animation%20art&width=1200&height=700&seq=news-cover-05&orientation=landscape",
    content: [
      "在强片云集的档期中，原创动画《小怪物大冒险》上演了一出精彩的逆袭。上映之初排片并不占优的它，凭借口碑一路攀升。",
      "影片讲述了一只被嫌弃的小怪物寻找自我的冒险旅程，温暖治愈的故事让不少成年观众也直呼「看哭了」。",
      "截至目前，该片的观众满意度居高不下，多家平台纷纷上调了对其最终票房的预期，被普遍认为是年度动画领域最大的黑马。",
    ],
  },
  {
    id: 6,
    title: "多部影片官宣重映，情怀经济持续升温",
    date: "2025-08-26",
    summary: "经典作品的重映正在成为一种稳定的市场现象，观众愿意为一次重温旧梦的体验买单。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20re-release%20news%20banner%2C%20audience%20silhouettes%20watching%20a%20bright%20screen%20in%20a%20dark%20cinema%2C%20warm%20amber%20glow%20and%20deep%20blue%20shadows%2C%20nostalgic%20warm%20mood%2C%20high%20detail%20editorial%20photography&width=1200&height=700&seq=news-cover-06&orientation=landscape",
    content: [
      "近期，多部曾经陪伴观众成长的作品陆续宣布重映，再度点燃了观众的情怀。",
      "分析人士指出，重映作品往往拥有坚实的口碑基础与情感连接，能够以较低的成本取得稳定的市场回报，因此越来越受到片方青睐。",
      "对于观众而言，重映提供的不仅是观影本身，更是一次与过去的自己重逢的机会。",
    ],
  },
  {
    id: 7,
    title: "影视行业观察：现实题材创作迎来新高峰",
    date: "2025-08-15",
    summary: "越来越多创作者将镜头对准普通人的生活，真实细腻的表达成为打动观众的关键。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20banner%2C%20close%20up%20of%20a%20vintage%20film%20camera%20on%20a%20busy%20city%20street%20at%20golden%20hour%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20observational%20realistic%20mood%2C%20high%20detail%20editorial%20photography&width=1200&height=700&seq=news-cover-07&orientation=landscape",
    content: [
      "近年来，现实题材影视作品的数量与质量都在稳步提升，成为行业内外共同关注的现象。",
      "创作者们不再满足于宏大的叙事，而是将目光投向普通人的日常，用细腻的笔触呈现生活的复杂与温度。",
      "评论认为，这种转变既反映了观众审美需求的变化，也体现了行业整体创作水平的提升。",
    ],
  },
  {
    id: 8,
    title: "技术观察：虚拟拍摄如何改变电影制作流程",
    date: "2025-08-03",
    summary: "从绿幕到实时渲染，新技术的应用正在重塑电影制作的效率与想象力边界。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20virtual%20production%20studio%20banner%2C%20filmmaker%20on%20a%20stage%20surrounded%20by%20giant%20led%20screens%20displaying%20virtual%20environments%2C%20deep%20blue%20and%20orange%20tones%2C%20futuristic%20creative%20mood%2C%20high%20detail%20editorial%20photography&width=1200&height=700&seq=news-cover-08&orientation=landscape",
    content: [
      "虚拟拍摄技术正在被越来越多的制作团队采用，它让创作者能够在现场就看到接近成片的画面效果。",
      "相比传统的绿幕抠像，虚拟拍摄大幅提升了演员的表演真实感与制作效率，同时降低了外景拍摄的成本与风险。",
      "不过，业内也提醒，技术始终是服务于内容的工具，讲好一个故事依然是电影创作的核心。",
    ],
  },
];